import template        from "./dropdown-item-shutdown.html";
import css             from "./dropdown-item-shutdown.css";

import {Dropdown}  from "gui";


class DropdownItemShutDown extends Dropdown.Item {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dropdown-item-shutdown", DropdownItemShutDown);
  }
  static get schema() {
    return({
      "description": "User defined shutdown item",
      "type": "object",
      "properties": {}
    });
  }
  static get designer() {
    return({
      "category": "User Defined",
      "icon": {"context": "actions", "size": 16, "iconname": "insert-button"}
    });
  }
  constructor(...args) {
    super(...args);
                
    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;
    
    if (devices.ups) {
      this.style.display = "none";
    } else {
      this.style.display = "flex";
    }
    
  }
}

DropdownItemShutDown.constructor();

export default DropdownItemShutDown;